import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import AboutCompany from '../Elements/AboutCompany';
import Specialization3 from '../Elements/Specialization3';
import OurServices3 from '../Elements/OurServices3';
import OurValue3 from '../Elements/OurValue3';
import OurProject3 from '../Elements/OurProject3';
import Faq from '../Elements/Faq';
import AboutCompany5 from './AboutCompany5';
import Specialization9 from './Specialization9';
import OurValue8 from './OurValue8';
import OurProject7 from '../Elements/OurProject7';
import OurProject8 from './OurProject8';
import Faq6 from './Faq6';

var bnrimg = require('./../../images/banner/1.jpg');

class BMS extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner title="Diversified services. Unvarying quality." pagename="Services" bgimage={bnrimg}/>
                    <AboutCompany5 />
                    <Specialization9 />
                    <OurValue8 />
                    <OurProject8 />
                    {/* <Faq6 /> */}
                <Footer />
                    
                </div>

                
               

            </>
        );
    };
};

export default BMS;